/** Sidebar nav catalog — metadata for every assignable nav item and dropdown group. */

import { collectNavIdsFromLayout } from './planSidebarEditorUtils';
import { isPathAllowedForRole, normalizePathname, ROLE } from './privateRouteAccess';

export const SIDEBAR_GROUPS = {
  group_school_management: { label: 'Academics', icon: 'CiBank' },
  group_students: { label: 'Students', icon: 'FcPortraitMode' },
  group_faculty_settings: { label: 'Staff', icon: 'LiaUserCogSolid' },
  group_school_settings: { label: 'Settings', icon: 'FcSettings' },
  group_fee_management: { label: 'Finance', icon: 'FcCurrencyExchange' },
  group_faculty_pages: { label: 'Classroom Tools', icon: 'FcBusinessman' },
  group_attendance_leave: { label: 'Attendance & Leave', icon: 'BsClipboard2' },
  group_operations: { label: 'Operations', icon: 'CiDeliveryTruck' },
  group_faculty_teaching: { label: 'Teaching', icon: 'BsJournalBookmark' },
  group_platform: { label: 'Platform', icon: 'BsGlobe2' },
  group_billing_hr: { label: 'Billing & HR', icon: 'CiBank' },
  group_thrillion_team: { label: 'Thrillion Team', icon: 'FaUsersLine' },
  group_schools_admin: { label: 'Schools', icon: 'ImOffice' },
  group_system_admin: { label: 'System', icon: 'FcSettings' },
  group_school_admins: { label: 'School Admins', icon: 'FaUserTie' },
};

export const SIDEBAR_NAV_ITEMS = {
  item1: { navId: 'item1', label: 'Dashboard', path: '/dashboard', icon: 'BiDesktop' },
  item9: { navId: 'item9', label: 'Dashboard', path: '/super-admins-dashboard', icon: 'BiDesktop' },
  item70: { navId: 'item70', label: 'Dashboard', path: '/faculty-dashboard', icon: 'MdSpaceDashboard' },
  item71: { navId: 'item71', label: 'Dashboard', path: '/luxehara/luxehara-dashboard', icon: 'CiDesktop' },
  item22: { navId: 'item22', label: 'Staff Home', path: '/staff-dashboard', icon: 'BiDesktop' },
  item108: { navId: 'item108', label: 'Demo Requests', path: '/demo-requests', icon: 'BsCalendar2Event' },
  item124: { navId: 'item124', label: 'All Schools', path: '/all-schools', icon: 'FaSchool' },
  item97: { navId: 'item97', label: 'Billing', path: '/super-admin/billing', icon: 'CiBank' },
  item107: { navId: 'item107', label: 'HR Payroll', path: '/super-admin/hr-payroll', icon: 'MdPayments' },
  item25: { navId: 'item25', label: 'Add Thrillion Staff', path: '/register-thrillion-staff', icon: 'FaClipboardUser' },
  item28: { navId: 'item28', label: 'View Thrillion Staff', path: '/view-thrillion-staff', icon: 'FaUsersLine' },
  item50: { navId: 'item50', label: 'Manage Schools', path: '/manage-schools', icon: 'ImOffice' },
  item95: { navId: 'item95', label: 'School Plans', path: '/super-admin/school-plans', icon: 'FaSearchDollar' },
  item84: { navId: 'item84', label: 'School Info', path: '/school-info', icon: 'BsInfoCircle' },
  item111: { navId: 'item111', label: 'School Website', path: '/school-website', icon: 'BsGlobe2' },
  item112: { navId: 'item112', label: 'Admission Enquiry', path: '/admissions-enquiry', icon: 'BsEnvelopePaper' },
  item115: { navId: 'item115', label: 'App Billing', path: '/app-billing', icon: 'CiBank' },
  item109: { navId: 'item109', label: 'Sidebar Layout', path: '/super-admin/sidebar-layout', icon: 'FcSettings' },
  item120: { navId: 'item120', label: 'Role Permissions', path: '/super-admin/role-permissions', icon: 'LiaUserCogSolid' },
  item23: { navId: 'item23', label: 'Add School Admins', path: '/register-school-admins', icon: 'FaUserTie' },
  item24: { navId: 'item24', label: 'View School Admins', path: '/view-all-school-admins', icon: 'CiUser' },
  item20: { navId: 'item20', label: 'Onboard School', path: '/onboard', icon: 'FcBriefcase' },
  item96: { navId: 'item96', label: 'Tickets', path: '/support-lead/tickets', icon: 'BsTicketPerforated' },
  item122: { navId: 'item122', label: 'Application Testing', path: '/application-testing', icon: 'BsClipboardCheck' },
  item11: { navId: 'item11', label: 'Diary Report', path: '/diary-info', icon: 'GoPaste' },
  item105: { navId: 'item105', label: 'View Teaching Plans', path: '/view-teaching-plans', icon: 'BsJournalBookmark' },
  item118: { navId: 'item118', label: 'Class Timetable', path: '/create-class-time-table', icon: 'CiCalendarDate' },
  item119: { navId: 'item119', label: 'View time table', path: '/view-class-time-table', icon: 'CiCalendarDate' },
  item2: { navId: 'item2', label: 'Add Student', path: '/add-student', icon: 'FcReading' },
  item5: { navId: 'item5', label: 'View Students', path: '/view-all-students', icon: 'FcConferenceCall' },
  item113: {
    navId: 'item113',
    label: 'Student promotion',
    path: '/student-promotion',
    icon: 'FcReading',
  },
  item114: {
    navId: 'item114',
    label: 'Alumni',
    path: '/alumni',
    icon: 'FcPortraitMode',
  },
  item3: { navId: 'item3', label: 'Add Faculty', path: '/add-faculty', icon: 'FaUserPlus' },
  item12: { navId: 'item12', label: 'View All Faculty', path: '/view-all-faculty', icon: 'FaUserTie' },
  item17: { navId: 'item17', label: 'Calendar', path: '/calendar', icon: 'CiCalendarDate' },
  item110: { navId: 'item110', label: 'Daily Updates', path: '/daily-updates', icon: 'HiOutlineCalendarDays' },
  item140: { navId: 'item140', label: 'Announcements', path: '/announcements', icon: 'HiOutlineBell' },
  item32: { navId: 'item32', label: 'Add Classes', path: '/add-classes', icon: 'FcLibrary' },
  item34: { navId: 'item34', label: 'Add Sections', path: '/add-sections', icon: 'FcFilingCabinet' },
  item6: { navId: 'item6', label: 'Add Subjects', path: '/add-subjects', icon: 'BsBookHalf' },
  item8: { navId: 'item8', label: 'Add Examination', path: '/add-examinations', icon: 'BiBookBookmark' },
  item78: { navId: 'item78', label: 'Add Subjects to Exam', path: '/assign-subjects-to-examination', icon: 'BsFileEarmarkPlus' },
  item10: { navId: 'item10', label: 'Add Academic Year', path: '/academic-year', icon: 'VscCalendar' },
  item88: { navId: 'item88', label: 'Leave policy', path: '/school-leave-policy', icon: 'BsClipboard2Check' },
  item116: { navId: 'item116', label: 'Assign Fee', path: '/assign-fee', icon: 'BsCurrencyRupee' },
  item117: { navId: 'item117', label: 'Dashboard', path: '/clerk-dashboard', icon: 'BiDesktop' },
  item33: { navId: 'item33', label: 'Collect Fees', path: '/fee-details-page', icon: 'CiBadgeDollar' },
  item106: { navId: 'item106', label: 'Fees Info', path: '/fees-info', icon: 'HiOutlineChartSquareBar' },
  item123: { navId: 'item123', label: 'Fee Reminders', path: '/fee-reminders', icon: 'HiOutlineBell' },
  item139: { navId: 'item139', label: 'Fee Arrears', path: '/fee-arrears', icon: 'CiReceipt' },
  item37: { navId: 'item37', label: 'Search Fee Details', path: '/collect-fees', icon: 'FaSearchDollar' },
  item102: { navId: 'item102', label: 'Employee Payroll', path: '/employee-payroll', icon: 'MdPayments' },
  item98: { navId: 'item98', label: 'Expense Ledger', path: '/expense-lodger', icon: 'CiReceipt' },
  item89: { navId: 'item89', label: 'Leave Requests', path: '/school-leave-requests-info', icon: 'BsClipboardData' },
  item90: { navId: 'item90', label: 'Assign Tasks', path: '/assign-tasks', icon: 'BsListTask' },
  item73: { navId: 'item73', label: 'Day-wise Attendance', path: '/view-attendance-page', icon: 'BsClipboard2' },
  item74: { navId: 'item74', label: 'Attendance Report', path: '/view-attendance-report', icon: 'BsClipboardData' },
  item104: { navId: 'item104', label: 'Transport', path: '/transportation-system', icon: 'CiDeliveryTruck' },
  item91: { navId: 'item91', label: 'Create Ticket', path: '/school-admin-tickets', icon: 'BsClipboardData' },
  item72: { navId: 'item72', label: 'Add Attendance', path: '/add-attendance-page', icon: 'BsClipboardCheck' },
  item77: { navId: 'item77', label: 'Add Subject Marks', path: '/add-individual-subject-marks', icon: 'BsFileRuled' },
  item80: { navId: 'item80', label: 'Marks Sheet', path: '/marks-sheet', icon: 'BsClipboardData' },
  item81: { navId: 'item81', label: 'Action plans', path: '/add-plan', icon: 'FaSearchDollar' },
  item79: { navId: 'item79', label: 'Add Complaint', path: '/add-complaint', icon: 'LiaAngry' },
  item83: { navId: 'item83', label: 'View Complaint', path: '/add-complaint', search: '?tab=view', icon: 'FaSearchDollar' },
  item87: { navId: 'item87', label: 'Leave Details', path: '/faculty-leave-details', icon: 'MdBeachAccess' },
  item103: { navId: 'item103', label: 'My Tasks', path: '/faculty/view-tasks', icon: 'BsListTask' },
  item99: { navId: 'item99', label: 'Add Diary', path: '/faculty/add-diary', icon: 'GoPaste' },
  item100: { navId: 'item100', label: 'View Diary', path: '/faculty/view-diary', icon: 'BsJournalText' },
  item121: { navId: 'item121', label: 'Study Material', path: '/study-material', icon: 'BsBookHalf' },
  item128: { navId: 'item128', label: 'Add Syllabus Planning', path: '/faculty/add-syllabus-planning', icon: 'BsJournalBookmark' },
  item129: { navId: 'item129', label: 'View Syllabus Planning', path: '/faculty/view-syllabus-planning', icon: 'BsJournalText' },
  item130: { navId: 'item130', label: 'View Syllabus', path: '/view-syllabus', icon: 'BsBookHalf' },
  item131: { navId: 'item131', label: 'Add Blogs', path: '/super-admin/add-blogs', icon: 'BsJournalBookmark' },
  item132: { navId: 'item132', label: 'Add News Articles', path: '/super-admin/add-news-articles', icon: 'BsJournalText' },
  item133: { navId: 'item133', label: 'My School Settings', path: '/my-school-settings', icon: 'MdTune' },
  item134: { navId: 'item134', label: 'Onboard Vendor Organization', path: '/super-admin/vendor-organizations', icon: 'BsBuildingAdd' },
  item135: { navId: 'item135', label: 'Dashboard', path: '/vendor/dashboard', icon: 'BiDesktop' },
  item136: { navId: 'item136', label: 'Vendor Staff', path: '/vendor/staff', icon: 'FaUsersLine' },
  item137: { navId: 'item137', label: 'Knowledge Base', path: '/knowledge-base', icon: 'BsJournalBookmark' },
  item138: { navId: 'item138', label: 'My Todos', path: '/my-todos', icon: 'BsListTask' },
  item51: { navId: 'item51', label: 'Add Orders', path: '/luxehara/add-orders', icon: 'CiShoppingCart' },
  item61: { navId: 'item61', label: 'All Orders', path: '/luxehara/all-orders', icon: 'CiDeliveryTruck' },
  item35: { navId: 'item35', label: 'Logout', path: '__logout__', icon: 'FaPowerOff' },
};

const link = (navId) => ({ kind: 'link', navId });
const group = (groupId, children) => ({ kind: 'group', groupId, children });

/** Shared layout: School Head (principal) and School Admin have the same permissions. */
const schoolAdminSidebarLayout = () => [
  link('item1'),
  link('item137'),
  group('group_school_management', [
    link('item17'),
    link('item110'),
    link('item140'),
    link('item11'),
    link('item105'),
    link('item118'),
    link('item121'),
    link('item130'),
  ]),
  group('group_students', [link('item2'), link('item5'), link('item113'), link('item114'), link('item112')]),
  group('group_faculty_settings', [link('item3'), link('item12')]),
  group('group_attendance_leave', [link('item73'), link('item74'), link('item89'), link('item90')]),
  group('group_fee_management', [
    link('item116'),
    link('item33'),
    link('item139'),
    link('item106'),
    link('item123'),
    link('item37'),
    link('item102'),
    link('item98'),
  ]),
  group('group_operations', [link('item104'), link('item91')]),
  group('group_faculty_pages', [
    link('item72'),
    link('item77'),
    link('item80'),
    link('item81'),
    link('item128'),
    link('item129'),
    link('item79'),
    link('item83'),
    link('item87'),
  ]),
  group('group_school_settings', [link('item133')]),
  link('item35'),
];

const schoolHeadSidebarLayout = () => schoolAdminSidebarLayout();

const facultyLayout = [
  link('item70'),
  link('item119'),
  link('item103'),
  group('group_faculty_teaching', [
    link('item72'),
    link('item77'),
    link('item80'),
    link('item81'),
    link('item128'),
    link('item129'),
    link('item79'),
    link('item83'),
    link('item99'),
    link('item100'),
  ]),
  link('item121'),
  link('item87'),
  link('item35'),
];

export const MANAGED_ROLE_IDS = [1, 2, 3, 4, 7, 8, 9, 11, 13, 14, 15, 16];

/** School Head (1) and School Admin (2) use the same sidebar layout. */
export const SCHOOL_SIDEBAR_ROLES = [1, 2];
export const SCHOOL_SIDEBAR_CANONICAL_ROLE = 2;

/** Roles whose menus school subscription plans can restrict. */
export const SCHOOL_PLAN_EDITOR_ROLES = [ROLE.SCHOOL_HEAD, ROLE.SCHOOL_ADMIN, ROLE.CLERK];

/** Never assignable on a subscription plan. */
const SCHOOL_PLAN_EXCLUDED_NAV_IDS = new Set(['item35', 'item107', 'item138']);

/** Hidden and unusable until re-enabled. Saved layouts may still contain these ids. */
export const DISABLED_NAV_IDS = new Set(['item138']);

export function isNavIdDisabled(navId) {
  const raw = String(navId || '').trim();
  if (!raw) return false;
  return DISABLED_NAV_IDS.has(raw) || DISABLED_NAV_IDS.has(raw.split('_')[0]);
}

export function stripDisabledNavFromLayout(layout) {
  if (!Array.isArray(layout)) return layout;
  const next = [];
  for (const node of layout) {
    if (!node) continue;
    if (node.kind === 'link') {
      if (!isNavIdDisabled(node.navId)) next.push(node);
      continue;
    }
    if (node.kind === 'group') {
      const children = stripDisabledNavFromLayout(node.children || []);
      if (children.length) next.push({ ...node, children });
      continue;
    }
    next.push(node);
  }
  return next;
}

export const ROLE_LABELS = {
  1: 'School Head / Principal',
  2: 'School Admin',
  3: 'Faculty',
  4: 'Class Teacher',
  7: 'Customer Support',
  8: 'Super Admin',
  9: 'Clerk',
  11: 'Luxehara Admin',
  13: 'Support Lead',
  14: 'Support Manager',
  15: 'Vendor Admin',
  16: 'Vendor Staff',
};

const clerkSidebarLayout = () => [
  link('item117'),
  link('item119'),
  link('item140'),
  link('item121'),
  group('group_students', [link('item2'), link('item5'), link('item112')]),
  group('group_fee_management', [link('item33'), link('item139'), link('item106'), link('item123'), link('item37'), link('item98')]),
  group('group_operations', [link('item104')]),
  link('item35'),
];

export const DEFAULT_LAYOUTS_BY_ROLE = {
  1: schoolHeadSidebarLayout(),
  2: schoolAdminSidebarLayout(),
  9: clerkSidebarLayout(),
  3: facultyLayout,
  4: [...facultyLayout],
  7: [
    link('item22'),
    group('group_platform', [link('item108'), link('item124'), link('item122')]),
    group('group_school_admins', [link('item23'), link('item24')]),
    group('group_schools_admin', [link('item20'), link('item50'), link('item84')]),
    link('item35'),
  ],
  13: [
    link('item22'),
    group('group_platform', [link('item108'), link('item124'), link('item122')]),
    group('group_school_admins', [link('item23'), link('item24')]),
    group('group_schools_admin', [link('item20'), link('item50'), link('item84')]),
    link('item96'),
    link('item35'),
  ],
  14: [
    link('item22'),
    group('group_platform', [link('item108'), link('item124'), link('item122')]),
    group('group_billing_hr', [link('item97')]),
    link('item120'),
    group('group_school_admins', [link('item23'), link('item24')]),
    group('group_schools_admin', [link('item20'), link('item50'), link('item84')]),
    link('item35'),
  ],
  8: [
    link('item9'),
    group('group_platform', [link('item108'), link('item124'), link('item122')]),
    group('group_billing_hr', [link('item97'), link('item107')]),
    group('group_thrillion_team', [link('item25'), link('item28')]),
    group('group_schools_admin', [link('item50'), link('item95'), link('item84')]),
    link('item96'),
    group('group_system_admin', [link('item131'), link('item132'), link('item109'), link('item120')]),
    link('item35'),
  ],
  11: [link('item71'), link('item51'), link('item61'), link('item35')],
  15: [link('item135'), link('item136'), link('item35')],
  16: [
    link('item22'),
    link('item20'),
    link('item23'),
    link('item24'),
    link('item124'),
    link('item50'),
    link('item84'),
    link('item135'),
    link('item35'),
  ],
};

export function getCatalogItem(navId) {
  return SIDEBAR_NAV_ITEMS[navId] || SIDEBAR_NAV_ITEMS[navId?.split('_')?.[0]];
}

/** Every assignable sidebar link for the “Add items” modal (all roles). */
export function getAllCatalogNavEntries() {
  return Object.entries(SIDEBAR_NAV_ITEMS)
    .filter(([, item]) => !isNavIdDisabled(item.navId))
    .map(([catalogKey, item]) => ({
      catalogKey,
      navId: item.navId,
      label: item.label,
      path: item.path,
      search: item.search || '',
      icon: item.icon,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
}

const ADMISSION_ENQUIRY_NAV_ID = 'item112';
const MY_SCHOOL_SETTINGS_NAV_ID = 'item133';

const STUDENT_PROMOTION_NAV_ID = 'item113';
const ALUMNI_NAV_ID = 'item114';

/**
 * New sidebar pages must be registered in ALL of:
 * - SIDEBAR_NAV_ITEMS (catalog entry with path + label)
 * - Default layouts for roles 1 / 2 / 9 (sidebarCatalog + sidebar_defaults.py)
 * - App route + privateRouteAccess + sidebarActiveNav.js
 * School plan "+" modal uses deriveSchoolPlanNavIds() — new school pages appear automatically
 * when they are on those role menus or allowed by route rules for head/admin/clerk.
 */

function _injectNavUnderGroup(layout, groupId, navId) {
  if (!Array.isArray(layout) || layout.length === 0) return layout;
  let changed = false;
  const next = layout.map((node) => {
    if (node?.kind !== 'group' || node.groupId !== groupId) {
      return node;
    }
    const children = Array.isArray(node.children) ? node.children : [];
    const has = children.some((c) => c?.kind === 'link' && c.navId === navId);
    if (has) return node;
    changed = true;
    return { ...node, children: [...children, { kind: 'link', navId }] };
  });
  return changed ? next : layout;
}

const ADMISSION_ENQUIRY_ROLES = [1, 2, 9];

function _prependNavUnderSchoolSettings(layout, navId) {
  if (!Array.isArray(layout) || layout.length === 0) return layout;
  let changed = false;
  const next = layout.map((node) => {
    if (node?.kind !== 'group' || node.groupId !== 'group_school_settings') {
      return node;
    }
    const children = Array.isArray(node.children) ? node.children : [];
    if (children[0]?.kind === 'link' && children[0]?.navId === navId) {
      return node;
    }
    changed = true;
    const without = children.filter((c) => !(c?.kind === 'link' && c.navId === navId));
    return { ...node, children: [{ kind: 'link', navId }, ...without] };
  });
  return changed ? next : layout;
}

export function ensureMySchoolSettingsNavInLayout(layout, roleId) {
  const rid = Number(roleId);
  if (!SCHOOL_SIDEBAR_ROLES.includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  return _prependNavUnderSchoolSettings(layout, MY_SCHOOL_SETTINGS_NAV_ID);
}

export function ensureSchoolWebsiteNavInLayout(layout, roleId) {
  // School Website now lives under My School Settings hub — do not inject into dropdown.
  return layout;
}

export function collapseSchoolSettingsToHubOnly(layout, roleId) {
  const rid = Number(roleId);
  if (!SCHOOL_SIDEBAR_ROLES.includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  let changed = false;
  const next = layout.map((node) => {
    if (node?.kind !== 'group' || node.groupId !== 'group_school_settings') {
      return node;
    }
    const children = Array.isArray(node.children) ? node.children : [];
    const onlyHub =
      children.length === 1 &&
      children[0]?.kind === 'link' &&
      children[0]?.navId === MY_SCHOOL_SETTINGS_NAV_ID;
    if (onlyHub) return node;
    changed = true;
    return {
      ...node,
      children: [{ kind: 'link', navId: MY_SCHOOL_SETTINGS_NAV_ID }],
    };
  });
  return changed ? next : layout;
}

export function ensureAdmissionEnquiryNavInLayout(layout, roleId) {
  const rid = Number(roleId);
  if (!ADMISSION_ENQUIRY_ROLES.includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  return _injectNavUnderGroup(layout, 'group_students', ADMISSION_ENQUIRY_NAV_ID);
}

export function ensureStudentPromotionNavInLayout(layout, roleId) {
  const rid = Number(roleId);
  if (!SCHOOL_SIDEBAR_ROLES.includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  return _injectNavUnderGroup(layout, 'group_students', STUDENT_PROMOTION_NAV_ID);
}

export function ensureAlumniNavInLayout(layout, roleId) {
  const rid = Number(roleId);
  if (!SCHOOL_SIDEBAR_ROLES.includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  return _injectNavUnderGroup(layout, 'group_students', ALUMNI_NAV_ID);
}

const FEE_ARREARS_NAV_ID = 'item139';

export function ensureFeeArrearsNavInLayout(layout, roleId) {
  const rid = Number(roleId);
  if (!SCHOOL_SIDEBAR_ROLES.includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  return _injectNavUnderGroup(layout, 'group_fee_management', FEE_ARREARS_NAV_ID);
}

const ANNOUNCEMENTS_NAV_ID = 'item140';

export function ensureAnnouncementsNavInLayout(layout, roleId) {
  const rid = Number(roleId);
  if (![1, 2, 9].includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  if (collectNavIdsFromLayout(layout).includes(ANNOUNCEMENTS_NAV_ID)) {
    return layout;
  }
  // Prefer Academics group; clerks may not have it — prepend near top.
  const withGroup = _injectNavUnderGroup(layout, 'group_school_management', ANNOUNCEMENTS_NAV_ID);
  if (collectNavIdsFromLayout(withGroup).includes(ANNOUNCEMENTS_NAV_ID)) {
    return withGroup;
  }
  const next = [...layout];
  const dashIdx = next.findIndex((n) => n?.kind === 'link' && n.navId === 'item117');
  const node = { kind: 'link', navId: ANNOUNCEMENTS_NAV_ID };
  if (dashIdx >= 0) {
    next.splice(dashIdx + 1, 0, node);
  } else {
    next.unshift(node);
  }
  return next;
}

export function ensureKnowledgeBaseNavInLayout(layout, roleId) {
  const rid = Number(roleId);
  if (!SCHOOL_SIDEBAR_ROLES.includes(rid) || !Array.isArray(layout) || layout.length === 0) {
    return layout;
  }
  const KNOWLEDGE_BASE_NAV_ID = 'item137';
  if (collectNavIdsFromLayout(layout).includes(KNOWLEDGE_BASE_NAV_ID)) {
    return layout;
  }
  const next = [...layout];
  const dashIdx = next.findIndex(
    (n) => n?.kind === 'link' && n.navId === 'item1'
  );
  const node = { kind: 'link', navId: KNOWLEDGE_BASE_NAV_ID };
  if (dashIdx >= 0) {
    next.splice(dashIdx + 1, 0, node);
  } else {
    next.unshift(node);
  }
  return next;
}

export function applySchoolSidebarLayoutPatches(layout, roleId) {
  let next = ensureMySchoolSettingsNavInLayout(layout, roleId);
  next = collapseSchoolSettingsToHubOnly(next, roleId);
  next = ensureAdmissionEnquiryNavInLayout(next, roleId);
  next = ensureStudentPromotionNavInLayout(next, roleId);
  next = ensureAlumniNavInLayout(next, roleId);
  next = ensureFeeArrearsNavInLayout(next, roleId);
  next = ensureAnnouncementsNavInLayout(next, roleId);
  return ensureKnowledgeBaseNavInLayout(next, roleId);
}

export function getDefaultLayoutForRole(roleId) {
  const layout = DEFAULT_LAYOUTS_BY_ROLE[Number(roleId)];
  const base = layout ? JSON.parse(JSON.stringify(layout)) : [];
  return stripDisabledNavFromLayout(applySchoolSidebarLayoutPatches(base, roleId));
}

export function getNavRoute(navItem) {
  if (!navItem) return '/';
  const base = navItem.path || '/';
  if (base === '__logout__') return base;
  return `${base}${navItem.search || ''}`;
}

function normalizeSchoolPlanNavId(navId) {
  if (navId === 'item107') return 'item116';
  return String(navId || '').trim();
}

function isCatalogEntryAllowedForSchoolPlanRoles(entry) {
  if (!entry?.path || entry.path === '__logout__') return false;
  const path = normalizePathname(String(entry.path).split('?')[0]);
  return SCHOOL_PLAN_EDITOR_ROLES.some((role) => isPathAllowedForRole(path, role));
}

/**
 * All sidebar nav ids assignable on school subscription plans.
 * Union of school head / admin / clerk default menus plus any catalog page
 * those roles can open (e.g. Assign Fee, Daily Updates).
 */
export function deriveSchoolPlanNavIds() {
  const ids = new Set();

  for (const roleId of SCHOOL_PLAN_EDITOR_ROLES) {
    const layout = getDefaultLayoutForRole(roleId);
    collectNavIdsFromLayout(layout).forEach((rawId) => {
      const navId = normalizeSchoolPlanNavId(rawId);
      if (navId && !SCHOOL_PLAN_EXCLUDED_NAV_IDS.has(navId)) {
        ids.add(navId);
      }
    });
  }

  Object.values(SIDEBAR_NAV_ITEMS).forEach((item) => {
    if (!isCatalogEntryAllowedForSchoolPlanRoles(item)) return;
    const navId = normalizeSchoolPlanNavId(item.navId);
    if (navId && !SCHOOL_PLAN_EXCLUDED_NAV_IDS.has(navId)) {
      ids.add(navId);
    }
  });

  return Array.from(ids);
}

/** @deprecated Prefer deriveSchoolPlanNavIds(); kept for imports that expect a list. */
export const SCHOOL_PLAN_NAV_IDS = deriveSchoolPlanNavIds();

/** Sidebar items assignable to a school subscription plan (+ modal catalog). */
export function getSchoolPlanNavEntries() {
  return deriveSchoolPlanNavIds()
    .map((navId) => {
      const item = getCatalogItem(navId);
      return {
        catalogKey: navId,
        navId,
        label: item?.label || navId,
        path: item?.path,
        search: item?.search || '',
        icon: item?.icon,
      };
    })
    .filter((entry) => entry.label && entry.path)
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
}
